export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      deliveryTypeMst: {
        deliveryTypeMstId: 1,
        deliveryTypeMstUuid: "deliverytypemst001",
        deliveryTypeName: "お知らせ",
        deliveryType: "normal",
        deliveryPriorityKbn: 1,
        cmsDisplayKbn: 1,
        ledDisplayKbn: 1,
        deliveryTypeStatus: 1,
        deliveryConfigFlg: 1,
        linkedNoticeTypes: [
          {
            noticeTypeMstUuid: 'noticeType007',
            noticeTypeName: '音声定時放送',
          },
          {
            noticeTypeMstUuid: 'noticeType006',
            noticeTypeName: 'アンケート',
          },
          {
            noticeTypeMstUuid: 'noticeType005',
            noticeTypeName: '音声告知',
          },
          {
            noticeTypeMstUuid: 'noticeType004',
            noticeTypeName: 'PDF',
          },
          {
            noticeTypeMstUuid: 'noticeType003',
            noticeTypeName: '動画添付',
          },
          {
            noticeTypeMstUuid: 'noticeType002',
            noticeTypeName: '画像添付',
          },
          {
            noticeTypeMstUuid: "noticeType001",
            noticeTypeName: "テキストのみ",
          },
        ]
      }
    }
  }
}